var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Routes, Route, BrowserRouter, Navigate } from "react-router-dom";
import ResetPassword from "./components/pages/forms/reset.password";
import PageGadArt from "./components/pages/gadart";
import CustomerForms from './sections/customer.forms/customer.forms';
import { GlobalStyle } from './styles/generalStyles';
import { PageBackgrops } from "./components/pages/backgrops";
function App() {
    var role = localStorage.getItem('role');
    return (_jsxs("div", __assign({ className: "App" }, { children: [_jsx(GlobalStyle, { role: role }), _jsx(BrowserRouter, { children: _jsxs(Routes, { children: [_jsx(Route, { path: "/", element: _jsx(Navigate, { to: "/login" }) }), _jsx(Route, { path: "/login", element: _jsx(CustomerForms, {}) }), _jsx(Route, { path: "/login?gadArt", element: _jsx(CustomerForms, {}) }), _jsx(Route, { path: "/registration", element: _jsx(CustomerForms, {}) }), _jsx(Route, { path: "/reset-password/:user/:code", element: _jsx(ResetPassword, {}) }), _jsx(Route, { path: "/gad-art", element: _jsx(PageGadArt, {}) }), _jsx(Route, { path: "/backdrops", element: _jsx(PageBackgrops, {}) })] }) })] })));
}
export default App;
